import { Pipe, PipeTransform } from '@angular/core';
import {
  ComponentDefinition,
  isStandaloneComponent,
  StandaloneComponentDefinition
} from '@shared/utils/common/components/component-definition';

@Pipe({
  name: 'isStandaloneComponent',
  standalone: true
})
export class isStandaloneComponentPipe implements PipeTransform {
  transform<C>(
    componentDefinition: ComponentDefinition<C> | StandaloneComponentDefinition<C>
  ): componentDefinition is StandaloneComponentDefinition<C> {
    return isStandaloneComponent(componentDefinition);
  }
}
